/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { jsx } from 'theme-ui';
import React from 'react';
import { Link } from '@bottlebooks/gatsby-theme-base/src';

export default function Menubar() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-4dd68a71 elementor-section-content-middle elementor-section-full_width elementor-section-height-default elementor-section-height-default"
      data-id="4dd68a71"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3994b181"
          data-id="3994b181"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-80ef820 elementor-widget elementor-widget-image"
              data-id="80ef820"
              data-element_type="widget"
              data-widget_type="image.default"
            >
              <div className="elementor-widget-container">
                <a href="https://northsouthwines.co.uk/">
                  <img
                    width={300}
                    height={127}
                    alt=""
                    data-srcset="https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-300x127.png 300w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-768x325.png 768w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-1024x433.png 1024w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-1536x650.png 1536w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-2048x867.png 2048w"
                    data-src="https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-300x127.png"
                    data-sizes="(max-width: 300px) 100vw, 300px"
                    className="attachment-medium size-medium ls-is-cached lazyloaded"
                    src="https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-300x127.png"
                    sizes="(max-width: 300px) 100vw, 300px"
                    srcSet="https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-300x127.png 300w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-768x325.png 768w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-1024x433.png 1024w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-1536x650.png 1536w, https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-2048x867.png 2048w"
                  />
                  <noscript>
                    &lt;img width="300" height="127"
                    src="https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-300x127.png"
                    class="attachment-medium size-medium" alt=""
                    srcset="https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-300x127.png
                    300w,
                    https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-768x325.png
                    768w,
                    https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-1024x433.png
                    1024w,
                    https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-1536x650.png
                    1536w,
                    https://northsouthwines.co.uk/wp-content/uploads/2021/04/North-South-Wines-Master-Logo-RGB-2048x867.png
                    2048w" sizes="(max-width: 300px) 100vw, 300px" /&gt;
                  </noscript>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-d9696cb"
          data-id="d9696cb"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-41358773 elementor-nav-menu__align-right elementor-nav-menu--stretch elementor-nav-menu--dropdown-tablet elementor-nav-menu__text-align-aside elementor-nav-menu--toggle elementor-nav-menu--burger elementor-widget elementor-widget-nav-menu"
              data-id={41358773}
              data-element_type="widget"
              data-settings='{"full_width":"stretch","submenu_icon":{"value":"<i class=\"fas fa-chevron-down\"><\/i>","library":"fa-solid"},"layout":"horizontal","toggle":"burger"}'
              data-widget_type="nav-menu.default"
            >
              <div className="elementor-widget-container">
                <nav
                  role="navigation"
                  className="elementor-nav-menu--main elementor-nav-menu__container elementor-nav-menu--layout-horizontal e--pointer-none"
                >
                  <Menu />
                </nav>
                <div
                  className="elementor-menu-toggle"
                  role="button"
                  tabIndex={0}
                  aria-label="Menu Toggle"
                  aria-expanded="false"
                  style={{}}
                >
                  <i
                    aria-hidden="true"
                    role="presentation"
                    className="eicon-menu-bar"
                  />{' '}
                  <span className="elementor-screen-only">Menu</span>
                </div>
                <nav
                  className="elementor-nav-menu--dropdown elementor-nav-menu__container"
                  role="navigation"
                  aria-hidden="true"
                  style={{ top: '41px', width: '1905px', left: '0px' }}
                >
                  <Menu tabIndex={-1} />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/** @param {{ tabIndex?: number }} props */
function Menu({ tabIndex }) {
  return (
    <ul
      id="menu-2-41358773"
      className="elementor-nav-menu"
      data-smartmenus-id={16661030261800952}
    >
      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-3021">
        <a
          href="https://northsouthwines.co.uk/"
          className="elementor-item"
          tabIndex={tabIndex}
        >
          Home
        </a>
      </li>
      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2982">
        <Link to="/partners/" className="elementor-item" tabIndex={tabIndex}>
          Partners
        </Link>
      </li>
      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-7494">
        <a
          href="https://northsouthwines.co.uk/about-us/"
          className="elementor-item has-submenu"
          tabIndex={tabIndex}
          id="sm-16661030261800952-1"
          aria-haspopup="true"
          aria-controls="sm-16661030261800952-2"
          aria-expanded="false"
        >
          Who we are
          <span className="sub-arrow">
            <i className="fas fa-chevron-down" />
          </span>
        </a>
        <ul
          className="sub-menu elementor-nav-menu--dropdown"
          id="sm-16661030261800952-2"
          role="group"
          aria-hidden="true"
          aria-labelledby="sm-16661030261800952-1"
          aria-expanded="false"
        >
          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7495">
            <a
              href="https://northsouthwines.co.uk/our-approach/"
              className="elementor-sub-item"
              tabIndex={tabIndex}
            >
              Our Approach
            </a>
          </li>
          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7496">
            <a
              href="https://northsouthwines.co.uk/meet-the-team/"
              className="elementor-sub-item"
              tabIndex={tabIndex}
            >
              Meet the Team
            </a>
          </li>
          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5914">
            <a
              href="https://northsouthwines.co.uk/brcgs-explained/"
              className="elementor-sub-item"
              tabIndex={tabIndex}
            >
              BRCGS
            </a>
          </li>
        </ul>
      </li>
      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-7494">
        <a
          href="https://northsouthwines.co.uk/sustainability/"
          className="elementor-item has-submenu"
          tabIndex={tabIndex}
          id="sm-16661030261800952-1"
          aria-haspopup="true"
          aria-controls="sm-16661030261800952-2"
          aria-expanded="false"
        >
          Sustainability
          <span className="sub-arrow">
            <i className="fas fa-chevron-down" />
          </span>
        </a>
        <ul
          className="sub-menu elementor-nav-menu--dropdown"
          id="sm-16661030261800952-2"
          role="group"
          aria-hidden="true"
          aria-labelledby="sm-16661030261800952-1"
          aria-expanded="false"
        >
          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7495">
            <a
              href="https://northsouthwines.co.uk/our-approach/"
              className="elementor-sub-item"
              tabIndex={tabIndex}
            >
              Our Approach
            </a>
          </li>
          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7496">
            <a
              href="https://northsouthwines.co.uk/meet-the-team/"
              className="elementor-sub-item"
              tabIndex={tabIndex}
            >
              Meet the Team
            </a>
          </li>
          <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-5914">
            <a
              href="https://northsouthwines.co.uk/brcgs-explained/"
              className="elementor-sub-item"
              tabIndex={tabIndex}
            >
              BRCGS
            </a>
          </li>
        </ul>
      </li>
      <li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-3500 current_page_item menu-item-4836">
        <Link
          to="/products/"
          aria-current="page"
          className="elementor-item elementor-item-active"
          tabIndex={tabIndex}
        >
          Products
        </Link>
      </li>
      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2256">
        <a
          href="https://northsouthwines.co.uk/contact-us/"
          className="elementor-item"
          tabIndex={tabIndex}
        >
          Contact Us
        </a>
      </li>
      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-6040">
        <a
          href="https://northsouthwines.co.uk/blog/"
          className="elementor-item"
          tabIndex={tabIndex}
        >
          What’s new
        </a>
      </li>
    </ul>
  );
}
